import { Context } from '@/context';
import { useContext } from 'react';

const useIsUserEditorOrAdmin = () => {
    const { state } = useContext(Context);
    const user = state?.user ?? {};

    if (!user) return false;

    // Verificar si el usuario es editor o admin
    return (
        user?.role?.toLowerCase() === 'editor' ||
        user?.role?.toLowerCase() === 'admin' ||
        user?.role?.toLowerCase() === 'administrador'
    );
};

export default useIsUserEditorOrAdmin;
